export default __webpack_public_path__ + "static/media/4.853b5393.png";